import { getCookie } from 'cookies-next/client'

import {
  COOKIE_AD_SERVER_USER_ID_NAME,
  cookiesGetEcondaVisitorId,
  cookiesGetOrGenerateRecommendationSessionId,
} from '../cookies'
import { experimentsActivatedBrowserStorageGet } from '../experiments/components/experimentsActivatedBrowserStorage'
import { type PublicGlobalConfig } from '../global-config'

import { type UdpTrackingMetadata } from './model/udpTrackingTypes'
import { udpTrackingBuildExperimentAssignments } from './udpTrackingBuildExperimentAssignments'

export const udpTrackingBuildMetadata = ({
  globalConfig,
  optimizelyVisitorId,
}: {
  globalConfig: Pick<PublicGlobalConfig, 'tenant'>
  optimizelyVisitorId?: string
}): UdpTrackingMetadata => {
  const sessionId = cookiesGetOrGenerateRecommendationSessionId()
  const asuid = getCookie(COOKIE_AD_SERVER_USER_ID_NAME)
  const econdaVisitorId = cookiesGetEcondaVisitorId()

  return {
    device: 'web',
    econda_visitor_id: econdaVisitorId,
    experiment_assignments: udpTrackingBuildExperimentAssignments(
      experimentsActivatedBrowserStorageGet(),
    ),
    optimizely_visitor_id: optimizelyVisitorId,
    session_id: sessionId,
    shop: globalConfig.tenant,
    timestamp: new Date().toISOString(),
    ...(asuid && { user_id: asuid }),
    visitor_id: sessionId,
  }
}
